var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Box } from '#design-system';
import { useFormRoot } from '#form-builder';
import { C } from '#integrations';
import styles from './ConditionalFieldsBox.module.css';
export const ConditionalFieldsBox = memo(_react_refresh_temp_1 = _react_refresh_temp_3(({ children, className, condition, hidden, ...restBoxProps }) => {
    _react_refresh_temp_3();
    const { formData } = useFormRoot();
    const shouldRenderChildren = useMemo(() => typeof condition === 'function'
        ? condition(formData)
        : condition, [condition, formData]);
    const shouldKeepChildrenInVirtualDOM = useMemo(() => (typeof hidden === 'function' ? hidden(formData) : hidden), [formData, hidden]);
    const { childrenToRender, containerClassName } = useMemo(() => {
        if (!shouldRenderChildren) {
            // Hide from view but keep in the virtual DOM:
            if (shouldKeepChildrenInVirtualDOM) {
                return {
                    childrenToRender: children,
                    containerClassName: styles.Hidden,
                };
            }
            else {
                // Remove children from view and from virtual DOM:
                return {
                    childrenToRender: null,
                    containerClassName: styles.Hidden,
                };
            }
        }
        return { childrenToRender: children, containerClassName: '' };
    }, [children, shouldKeepChildrenInVirtualDOM, shouldRenderChildren]);
    return (_jsx(Box, { className: C(className, containerClassName), ...restBoxProps, children: childrenToRender }));
}, "rAZkVgx/k8a0Rv1bUMWxgoSfIj4=", false, () => [useFormRoot]));
$RefreshReg$(_react_refresh_temp_1, "ConditionalFieldsBox$memo");
_react_refresh_temp_2 = ConditionalFieldsBox;
$RefreshReg$(_react_refresh_temp_2, "ConditionalFieldsBox");
